import { AdminContractCreatePage } from "@/pages/admin-contract-create";
import { createFileRoute, useParams } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth_requeired/admin/delivery-proposals/$id/contracts/create",
)({
  component: () => {
    const { id } = useParams({ strict: false });
    return <AdminContractCreatePage deliveryProposalOfferCargoIdStr={id} />;
  },
});
